export const InstagramUrl = 'https://www.instagram.com/khanoumi_shop'
export const LinkedinUrl = 'https://www.linkedin.com/company/khanoumi'
export const TelegramUrl = 'https://t.me/khanoumi_com'
export const BaleUrl = 'https://ble.ir/khanoumishop'
export const Email = 'info@khanoumi.com'

export const PhoneNumber = {
    international: '02191200500',
    local: '02191200500',
    delimited: '021-91200500',
    value: '02191200500',
}
